/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
// useState
import { Tabs, Button, Card } from 'antd';

import PriceBreakTab from '../../../components/DibbsTabs/priceBreakTab';

const { TabPane } = Tabs;

const Header = block => {
  const { data } = block;
  const [activeKey, setActiveKey] = useState('0');

  const onTabChange = newKey => {
    if (newKey) setActiveKey(newKey);
  };
  const onButtonClick = (forward, location) => {
    let change = 0;
    if (forward) {
      change = 1;
    } else {
      change = -1;
    }
    const activeNum = Number(activeKey) + change;
    console.log(location);
    console.log(data.values[activeNum]);
    if (data.values[activeNum]) {
      setActiveKey(activeNum.toString());
    } else {
      data.changeMenus(location);
    }
  };

  const test = () => {
    data.createPriceBreak();
    const activeNum = Number(activeKey) + 1;
    if (data.values[activeNum]) {
      setActiveKey(activeNum.toString());
    } else {
      setActiveKey('0');
    }
  };
  const tabBuilder = () =>
    data.values.map((value, index) => {
      console.log(value);
      // Use a unique identifier from value, fallback to index if not present (but ideally always have an id)
      const key = value.id ? value.id.toString() : `price-break-${index}`;
      return (
        <TabPane tab={`Price Break ${index}`} key={key}>
          <PriceBreakTab
            values={value}
            changeValues={(fieldKey, value1) => {
              data.changeValues(fieldKey, value1, index);
            }}
            quoteValues={data.quoteValues}
            changeQuoteValues={data.changeQuoteValues}
          />
        </TabPane>
      );
    });

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Price Breaks</div>
      {data.values[0] && (
        <Tabs activeKey={activeKey} onChange={onTabChange}>
          {tabBuilder()}
        </Tabs>
      )}
      <Button
        onClick={() => {
          test();
        }}
      >
        Add Price Break?
      </Button>{' '}
      {!data.values[0] && <Card> No Price Breaks for this solicitation </Card>}
      <div className="wizard-button-wrapper">
        <Button
          onClick={() => {
            onButtonClick(false, 'pricing');
          }}
        >
          Previous
        </Button>
        <Button
          onClick={() => {
            onButtonClick(true, 'product');
          }}
          type="primary"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsPriceBreaks.jsx